import React from 'react';
import GameRoomPlayer from './GameRoomPlayer';
import { GameRoomPlayersInterface } from './GameRoomPlayersInterface';
import { getScore } from '../utils/ScoresUtils';

function GameRoomSixPlayers({players, currentRound, roundBlackCards, roundPhase, scoresMap, shouldShowHand}: GameRoomPlayersInterface) {

    return (
        <div className="playersWrapper">
            <div className="sixPlayersWrapper1">
                <GameRoomPlayer player={players[5]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[5].id)} shouldShowHand={shouldShowHand} />
            </div>
            <div className="sixPlayersWrapper2">
                <GameRoomPlayer player={players[3]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[3].id)} shouldShowHand={shouldShowHand} />
                <GameRoomPlayer player={players[4]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[4].id)} shouldShowHand={shouldShowHand} />
            </div>
            <div className="sixPlayersWrapper3">
                <GameRoomPlayer player={players[1]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[1].id)} shouldShowHand={shouldShowHand} />
                <GameRoomPlayer player={players[2]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[2].id)} shouldShowHand={shouldShowHand} />
            </div>
            <div className="sixPlayersWrapper4">
                <GameRoomPlayer player={players[0]} round={currentRound} roundBlackCards={roundBlackCards} roundPhase={roundPhase} score={getScore(scoresMap, players[0].id)} shouldShowHand={shouldShowHand} />
            </div>
        </div>
    );
};

export default GameRoomSixPlayers;